import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery } from "@mui/material";
// material-ui
import { styled, useTheme } from "@mui/material/styles";
// assets
import { IconChevronRight } from "@tabler/icons";
// import Customization from '../Customization';
import navigation from "menu-items";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { setMenu } from "store/actions";
import { drawerWidth } from "store/constant";
import { customizationActions } from "store/customization";
// project imports
import Breadcrumbs from "ui-component/extended/breadcrumbs";
import Header from "./header";
import Sidebar from "./sidebar";

// styles
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
  ...theme.typography.mainContent,
  ...(!open && {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    zIndex: 2,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up("xl")]: {
      marginLeft: -(drawerWidth - 20),
      zIndex: 2,
      width: `calc(100% - ${drawerWidth}px)`
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: "20px",
      width: `calc(100% - ${drawerWidth}px)`,
      zIndex: 2,
      padding: "16px"
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "10px",
      width: `calc(100% - ${drawerWidth}px)`,
      padding: "16px",
      zIndex: 2,
      className: "dfdf",
      marginRight: "10px"
    }
  }),
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0,
    paddingBottom: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    width: `calc(100% - ${drawerWidth}px)`,
    [theme.breakpoints.down("md")]: {
      marginLeft: "20px"
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "10px"
    }
  })
}));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down("xl"));
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  // const storeInitialized = useSelector((state) => state.initialValues.storeInitialized);
  // Handle left drawer
  const leftDrawerOpened = useSelector((state) => state.customization.opened);
  const dispatch = useDispatch();
  const handleLeftDrawerToggle = () => {
    dispatch(customizationActions.setMenu(!leftDrawerOpened));
  };

  useEffect(() => {
    dispatch(setMenu(!matchDownMd));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownMd]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {/* header */}
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        className="mymyu"
        elevation={0}
        sx={{
          bgcolor: theme.palette.background.default,
          zIndex: 99,
          transition: leftDrawerOpened ? theme.transitions.create("width") : "none"
        }}
      >
        <Toolbar className="ssdd" sx={{ padding: 0, paddingTop: 1 }}>
          <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
        </Toolbar>
      </AppBar>

      {/* drawer */}
      <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />

      {/* main content */}
      <Main className="llkk" theme={theme} open={leftDrawerOpened}>
        {/* breadcrumb */}
        <Breadcrumbs separator={IconChevronRight} navigation={navigation()} icon title rightAlign />
        <Outlet />
      </Main>
      {/* <Customization /> */}
    </Box>
  );
};

export default MainLayout;
